<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="propertyLeadProfiles" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="propertyLeadProfileId" selectionMode="single"
  [(selection)]="ownerPropertyDetail" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h2 style="float: left;margin: 6px;">Property Lead Profiles</h2>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">Property Lead Profile +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <!-- <p-sortIcon [field]="col.field"></p-sortIcon> -->
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th><p-multiSelect [options]="statuses" displaySelectedLabel
        optionLabel="name" appendTo="body" (onChange)="pt.filter($event.value, 'status', 'in')"></p-multiSelect>
      </th>
      <!-- Join table contains only Ids of property and owner hence can not filter or sort columns-->
      <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyLeadProfileGuestAPI?.subjAdrDevelopmentName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyLeadProfileGuestAPI?.subjAdrStreet', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyLeadProfileGuestAPI?.subjAdrUnit', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyLeadProfileGuestAPI?.subjAdrCity', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyLeadProfileGuestAPI?.subjAdrState', 'in')"></th> -->
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-propertyLeadProfile>
  <tr [pSelectableRow]="propertyLeadProfile">
    <td>{{getStatusName(propertyLeadProfile)}}</td>
    <td>{{propertyLeadProfile?.propertyLeadProfileGuestAPI?.subjAdrDevelopmentName}}</td>
    <td>{{propertyLeadProfile?.propertyLeadProfileGuestAPI?.subjAdrStreet}}</td>
    <td>{{propertyLeadProfile?.propertyLeadProfileGuestAPI?.subjAdrUnit}}</td>
    <td>{{propertyLeadProfile?.propertyLeadProfileGuestAPI?.subjAdrCity}}</td>
    <td>{{propertyLeadProfile?.propertyLeadProfileGuestAPI?.subjAdrState}}</td>
    <td>
      <span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(propertyLeadProfile)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>